import validateOtp from "../../apis/validate-otp/validate-otp";
import getUserId from "../../apis/get-user-id/get-user-id";
import getUserData from "../../apis/get-user-data/get-user-data";
import generateMobileOtp from "../../apis/generate-mobile-otp/generate-mobile-otp";

const LoginServiceObject = {};

const getUserDataService = (getUserDataV3Request) => {

  return new Promise((resolve, reject) => {
    getUserData(getUserDataV3Request)
      .then((getUserDataV3response) => {

        if (getUserDataV3response.header.status === "SUCCESS") {
          resolve(getUserDataV3response);
        } else {
          reject("11");
        }
      })
      .catch((error) => {
        reject("10");
      });
  });
};
LoginServiceObject.getUserDataService = getUserDataService;

const generateMobOtpService = (requestJson, serviceType) => {
  return new Promise((resolve, reject) => {
    generateMobileOtp(requestJson)
      .then((generateOtpResponse) => {
        console.log(generateOtpResponse);
        if (generateOtpResponse.header.status.toUpperCase() === "SUCCESS") {
          if (generateOtpResponse.body.retStatus.toUpperCase() === "SUCCESS") {
            resolve(generateOtpResponse);
          } else {
          }
        } else if (generateOtpResponse.header.status.toUpperCase() === "FAILURE") {
          if (generateOtpResponse.errorBody) {
            if (generateOtpResponse.errorBody.message) {
              if (
                generateOtpResponse.errorBody.message
                  .toLowerCase()
                  .search("empty user data") !== -1
              ) {
                if (serviceType === "mobile") {
                  reject("Please Provide Your Registered Mobile No");
                }
              }
              else {
                reject("02");
              }
            } else {
              reject("02");
            }
          } else {
            reject("02");
          }

        }
      })
      .catch((error) => {
        reject("02");
      });
  });
};

LoginServiceObject.generateMobOtpService = generateMobOtpService;

const validateOtpService = (reqobj) => {

  return new Promise((resolve, reject) => {
    // let requestObj;
    // requestObj = {
    //   header: {
    //     grantType: "otp",
    //     serviceType: "mobile",
    //     authToken: authToken,
    //     context: "login",
    //   },
    //   body: {
    //     mobileNo: userInput,
    //     otpRef: refNo,
    //     otp: otp,
    //   },
    // }
    validateOtp(reqobj)
      .then((validateOtpResponse) => {
        if (validateOtpResponse != undefined) {
          if (validateOtpResponse.header.status.toUpperCase() === "SUCCESS") {
            if (validateOtpResponse.body.retStatus.toUpperCase() === "SUCCESS") {
              resolve(validateOtpResponse);
            } else {
              reject("Something went wrong")
            }
          } else if (validateOtpResponse.header.status.toUpperCase() === "FAILURE") {
            if (validateOtpResponse.errorBody.retStatus == "FAILURE" && validateOtpResponse.errorBody.errorMessage.length > 0) {
              reject("invalid otp");
            } else {
              reject("Something went wrong")
            }
          }

        } else {
          reject("Something went wrong")
        }
      })
      .catch((error) => {
        reject("We are experiencing some technical difficulty. Please try after sometime.");
      });
  });
};
LoginServiceObject.validateOtpService = validateOtpService;

const getUserIdService = (requestObj, userInput) => {
  return new Promise((resolve, reject) => {
    // let requestObj;
    // requestObj = {
    //   header: {
    //     authToken: authToken,
    //   },
    //   body: {
    //     mobileNo: userInput,
    //   },
    // };
    getUserId(requestObj)
      .then((getUserIdResponse) => {

        if (getUserIdResponse.header.status === "SUCCESS") {
          resolve(getUserIdResponse);
        } else {
          reject(`Hey! It seems this number is not registered with us. To continue as "New Customer" click below.`)
        }
      })
      .catch((error) => {
        reject();
      });
  });
};
LoginServiceObject.getUserIdService = getUserIdService;

export default LoginServiceObject;
